export const MAX_UPLOAD_SIZE_MB = 5;

export function validateFileSize(file: File, maxMb: number = MAX_UPLOAD_SIZE_MB): string | null {
    const maxBytes = maxMb * 1024 * 1024;
    if (file.size > maxBytes) {
        const actualMb = file.size / (1024 * 1024);
        return `Your file is ${actualMb.toFixed(1)} MB, which is too large. Please upload a file under ${maxMb} MB.`;
    }
    return null;
}
